module.exports = __webpack_public_path__ + "img/p1.526c073c.png";